












import {Component, Vue} from "vue-property-decorator";
import Treeselect from "@/lib/vue-treeselect/src/components/Treeselect.vue";

const components = {
  Treeselect,
};

@Component({ components })
export default class CsTreeSelect extends Vue {
    private updated(): void {
      this.$nextTick(() => {
        const treeSelectComponent = this.$refs.treeSelect as Vue;
        if (!treeSelectComponent) {
          return;
        }

        const treeSelectElement = treeSelectComponent.$el;

        const arrowContainers: NodeListOf<HTMLElement> = treeSelectElement.querySelectorAll(
          ".vue-treeselect__control-arrow-container"
        );
        Array.from(arrowContainers).forEach((arrowContainer: HTMLElement) => {
          arrowContainer.innerHTML = "<i class='el-select__caret el-input__icon el-icon-arrow-down'></i>";
        });

        const closeButtonContainers: NodeListOf<HTMLElement> = treeSelectElement.querySelectorAll(
          ".vue-treeselect__x-container"
        );
        Array.from(closeButtonContainers).forEach((closeButtonContainer: HTMLElement) => {
          if (closeButtonContainer) {
            closeButtonContainer.innerHTML = "<i class='el-tag__close el-icon-close'></i>";
          }
        });
      });
    }

    private toggleArrowRotation(state: string, event: any): void {
      const treeSelectComponent = this.$refs.treeSelect as Vue;
      if (!treeSelectComponent) {
        return;
      }

      const treeSelectElement = treeSelectComponent.$el;

      const arrowIcons: NodeListOf<HTMLElement> = treeSelectElement.querySelectorAll(
        ".vue-treeselect__control-arrow-container i"
      );

      Array.from(arrowIcons).forEach((arrowIcon: HTMLElement) => {
        arrowIcon.style.transform = state === "open" ? "rotate(180deg)" : "rotate(0deg)";
      });

      this.$emit(state, event);
    }
}
